import axiosInstance from "../helpers/axiosInstance"

const BASE = process.env.REACT_APP_PLATFORM_URL

export const listUberBatches = async (params = {}) => {
    const res = await axiosInstance.get(`${BASE}/api/v1/uber_batches`, { params })
    return res.data
}

export const getUberBatch = async (id) => {
    const res = await axiosInstance.get(`${BASE}/api/v1/uber_batches/${id}`)
    return res.data?.uber_batch || res.data
}

/**
 * Manually flush pending UberBatch deliveries for a warehouse, bypassing the
 * automatic 60-second debounce.
 * @param {number} warehouse_id
 * @returns {{ enqueued: boolean, warehouse_id: number, pending_count: number }}
 */
export const submitPendingUberBatches = async (warehouse_id) => {
    const res = await axiosInstance.post(`${BASE}/api/v1/uber_batches/submit`, { warehouse_id })
    return res.data  // { enqueued, warehouse_id, pending_count }
}

/**
 * Look up an UberBatch by warehouse + internal label.
 * Returns the batch info on 200, or { internal_label, editable: true, exists: false } on 404.
 * Any other error is re-thrown.
 * @param {number} warehouse_id
 * @param {string} internal_label
 * @returns {{ id?, internal_label, status?, deliveries_count?, editable, exists? }}
 */
export const lookupUberBatch = async (warehouse_id, internal_label) => {
    try {
        const res = await axiosInstance.get(`${BASE}/api/v1/uber_batches/lookup`, {
            params: { warehouse_id, internal_label }
        })
        return res.data
    } catch (e) {
        if (e?.response?.status === 404 && e.response.data?.exists === false) {
            return e.response.data
        }
        throw e
    }
}

/**
 * Retry a failed UberBatch (failure_reason: uber_rejected_at_submission).
 * Resets the batch and its rejected deliveries back to pending; resubmission
 * happens via the dispatch-window cron or the "submit pending" action.
 * @param {number|string} id
 * @returns {{ uber_batch: object }}
 */
export const retryUberBatch = async (id) => {
    const res = await axiosInstance.post(`${BASE}/api/v1/uber_batches/${id}/retry`)
    return res.data
}
